export default "__VITE_ASSET__BzCUnvCQ__"